import {PayloadAction, createSlice} from '@reduxjs/toolkit';

export enum LogoutMsg {
  LOGOUT = 'logout',
  TIMEOUT = 'timeout',
}

export interface LogoutAction {
  msg?: LogoutMsg;
  forwardUrl?: string;
}

export interface AuthState {}

export const initialState: AuthState = {};

const {actions: AuthActions, reducer: AuthReducer} = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout(_state, _action: PayloadAction<LogoutAction>) {
      localStorage.removeItem('persist:mfa_shared_library');
      localStorage.removeItem('persist:myrewards');
      return initialState;
    },
    changeUser() {
      localStorage.removeItem('persist:mfa_shared_library');
    },
  },
});

export {AuthActions, AuthReducer};
export default AuthReducer;
